import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {MatBottomSheet} from '@angular/material';
import {Subscription} from 'rxjs';
import {ConsentsFormService} from '../../../../services/consents-form.service';
import {HeaderService} from '../../../../services/header.service';
import {SortConsentBottomSheetComponent} from '../sort-consent-bottom-sheet/sort-consent-bottom-sheet.component';

@Component({
    selector: 'app-available-consents',
    templateUrl: './available-consents.component.html',
    styleUrls: ['./available-consents.component.scss']
})
export class AvailableConsentsComponent implements OnInit, OnDestroy {
    listHeight: number;
    @Input() consents: any[] = [];
    @Input() currentUser: any;
    subscription: Subscription;

    constructor(private bottomSheet: MatBottomSheet,
                public consentsFormService: ConsentsFormService,
                private headerService: HeaderService) {
        this.listHeight = window.innerHeight - 100;
    }

    ngOnInit(): void {
        this.initSubscriptions();
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    initSubscriptions() {
        this.subscription = this.headerService.observerShowBottomSheet().subscribe(state => {
            if (state) {
                this.openBottomSheet();
            }
        });
    }

    sortConsents(sortBy: string = null, type: string = null, direction: string = null) {
        try {

            if (direction) {
                if (direction === 'asc') {
                    if (type === 'date') {
                        this.consents.sort((a, b) => (this.stringToDate(a[sortBy]) > this.stringToDate(b[sortBy])) ? 1 : (this.stringToDate(b[sortBy]) > this.stringToDate(a[sortBy])) ? -1 : 0);
                    } else {
                        this.consents.sort((a, b) => (a[sortBy] > b[sortBy]) ? 1 : (b[sortBy] > a[sortBy]) ? -1 : 0);
                    }
                } else {
                    if (type === 'date') {
                        this.consents.sort((a, b) => (this.stringToDate(a[sortBy]) < this.stringToDate(b[sortBy])) ? 1 : (this.stringToDate(b[sortBy]) < this.stringToDate(a[sortBy])) ? -1 : 0);
                    } else {
                        this.consents.sort((a, b) => (a[sortBy] < b[sortBy]) ? 1 : (b[sortBy] < a[sortBy]) ? -1 : 0);
                    }
                }
            }
        } catch (e) {
            console.log(e);
        }
    }

    openBottomSheet() {
        const bottomSheet = this.bottomSheet.open(SortConsentBottomSheetComponent, {
            data: {
                items: [
                    {
                        key: 'notificationDate',
                        label: 'Ημερομηνία δημοσίευσης',
                        type: 'date',
                        order: {key: 'asc', label: 'Αύξουσα σειρά'}
                    },
                    {
                        key: 'notificationDate',
                        label: 'Ημερομηνία δημοσίευσης',
                        type: 'date',
                        order: {key: 'desc', label: 'Φθίνουσα σειρά'}
                    },
                    {
                        key: 'formTitle',
                        label: 'Τίτλος δημοσίευσης',
                        type: 'string',
                        order: {key: 'asc', label: 'Αύξουσα σειρά'}

                    },
                    {
                        key: 'formTitle',
                        label: 'Τίτλος δημοσίευσης',
                        type: 'string',
                        order: {key: 'desc', label: 'Φθίνουσα σειρά'}

                    },
                    {
                        key: 'first_name',
                        label: 'Ονοματεπώνυμο χρήστη',
                        type: 'string',
                        order: {key: 'asc', label: 'Αύξουσα σειρά'}
                    },
                    {
                        key: 'first_name',
                        label: 'Ονοματεπώνυμο χρήστη',
                        type: 'string',
                        order: {key: 'desc', label: 'Φθίνουσα σειρά'}
                    },

                ]
            }
        });

        bottomSheet.afterDismissed().subscribe(response => {
            if (response) {
                this.sortConsents(response.key, response.type, response.order.key);
                this.headerService.setShowBottomSheet(false);
            }
        });
    }

    private stringToDate(dateString: string): Date {
        try {
            const tempString = dateString.split('-');
            const tempTime = tempString[2].split(' ');
            const year = tempTime[0];
            const month = tempString[1];
            const day = tempString[0];
            const time = tempTime[1];

            const formattedDateString = `${year}-${month}-${day} ${time}`;
            return new Date(formattedDateString);
        } catch (e) {
            return null;
        }
    }

    async showConsent(consent: any) {
        const notification = { id: consent.id, unique_id: consent.unique_id };
        const child = { id: consent.childId };
        await this.consentsFormService.showCustomForm(notification, this.currentUser, child);
    }
}
